<template>
    <div>
        <el-container>
            <el-main>
                <el-row
                    style="border: 1px solid #d7dae2; padding: 10px; border-radius: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
                    v-show="ishasData"
                    :key="items.id"
                    v-for="items in balanceArr"
                >
                    <el-col :span="24">
                        <h2 style="margin-bottom: 10px; float: left; color: #ab8f07">{{ items.name }}</h2>
                        <h4 style="float: right; color: #ab8f07" v-html="groupTitle(items)"></h4>
                    </el-col>
                    <el-col :span="24">
                        <el-row :gutter="20" :style="{ overflow: 'auto' }">
                            <el-col :span="8" :key="item.id" v-for="item in items.data">
                                <el-card
                                    shadow="hover"
                                    style="height: 280px; margin-bottom: 18px; font-weight: 600; min-width: 290px;"
                                >
                                    <div slot="header">
                                        <span :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">{{ item.BalanceName }}</span>
                                        <!-- <span :class="[item.Connect == '连接成功' ? 'spyes' : 'spno']">{{ item.Connect }}</span> -->
                                        <span class="spstate">
                                            <el-tag effect="dark" size="medium" :type="item.Connect == '连接成功' ? 'success' : 'danger'">{{
                                                item.Connect
                                            }}</el-tag></span
                                        >
                                    </div>
                                    <el-card shadow="never" style="margin-bottom: 10px">
                                        <div class="grid-con-1">
                                            <div class="user-info-list odd">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">原料</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ item.DisplayName }}
                                                </div>
                                            </div>
                                            <div class="user-info-list">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">
                                                    设定流量(t/h)
                                                </div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ item.fsetFlow }}
                                                </div>
                                            </div>
                                            <div class="user-info-list odd">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">累计(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ item.totalOutput }}
                                                </div>
                                            </div>
                                            <div class="user-info-list">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">流量(t/h)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ item.insFlow }}
                                                </div>
                                            </div>
                                            <div class="user-info-list odd">
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">带速(m/s)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ item.beltSpeed }}
                                                </div>
                                            </div>
                                        </div>
                                    </el-card>
                                    <!-- <el-card shadow="never">
                                        <div class="grid-con-1">
                                            <div
                                                :class="[index % 2 == 0 ? 'user-info-list odd' : 'user-info-list']"
                                                :key="newItem.name"
                                                v-for="(newItem, index) in item.Data"
                                            >
                                                <div :class="[item.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']">{{ newItem.name }}(t)</div>
                                                <div :class="[item.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']">
                                                    {{ newItem.freWeight }}
                                                </div>
                                            </div>
                                        </div>
                                    </el-card> -->
                                </el-card>
                            </el-col>

                            <el-col :span="8" v-if="!ishasData">
                                <el-row>
                                    <el-col :span="12">
                                        <el-card shadow="hover" style="height: 300px; margin: 10px">
                                            <img src="../../assets/img/searchempty.jpg" class="image" style="height: 240px; border-radius: 50%" />

                                            <div class="user-info-list">
                                                <span style="margin-left: 40%">查无数据</span>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
        <!-- 编辑弹出框 -->
        <el-dialog title="欢迎登录" :visible.sync="showLogin" width="20%" :close-on-click-modal="false" @close="setClose">
            <div class="ms-login">
                <!-- <div class="ms-title">欢迎登录</div> -->
                <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                    <el-form-item prop="username">
                        <el-input v-model="param.username" placeholder="username">
                            <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" placeholder="password" v-model="param.password" @keyup.enter.native="submitForm()">
                            <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                        </el-input>
                    </el-form-item>
                    <div class="login-btn">
                        <el-button type="primary" @click="submitForm()">登录</el-button>
                    </div>
                    <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { GroupbyName } from '../../utils/helper';
export default {
    data() {
        return {
            param: {
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            showLogin: false,
            isshow: false,
            screenheight: '',
            name: localStorage.getItem('ms_username'),
            structArr: [],
            balanceArr: [],
            columnNum: 6,
            ishasData: true,
            timer: 0
        };
    },
    filters: {
        formateDu(value) {
            return value;
        }
    },
    created() {
        // this.getData();
        this.getstructArr();
    },
    mounted: function () {
        this.timer = setInterval(() => {
            var indexof = (window.location.hash + '').indexOf('ScaleIndex');
            if (indexof >= 0) {
                setTimeout(this.getstructArr(), 0);
            }
        }, 1000 * 6);

        this.timer = setInterval(() => {
            setTimeout(this.updateShowLogin(), 0);
        }, 1000);
    },
    methods: {
        setClose(){
              localStorage.setItem('showLogin', 'no');  
        },
        updateShowLogin() {
            var showL = localStorage.getItem('showLogin');
            if (showL == 'yes') {
                this.showLogin = true;
            } else {
                this.showLogin = false;
            }
        },
        submitForm() {
            this.$refs.login.validate((valid) => {
                if (valid) {
                    // 跳转登陆
                    //var pwd=  DecPwd(this.param.password,this.param.username);
                    var pwd = this.param.password;
                    this.$zybhttp
                        .post('Account/SignIn', { loginid: this.param.username, pwd: pwd })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$message.success(res.data.msg);
                                localStorage.setItem('ms_username', this.param.username);
                                localStorage.setItem('ms_userInfo', JSON.stringify(res.data.data));

                                localStorage.setItem('showLogin', 'no');
                                this.editVisible = false;
                                this.$router.go(0);
                            } else {
                                this.$notify.error(res.data.msg);
                                return;
                            }
                        })
                        .catch((err) => this.$notify.error('网络异常！'));
                } else {
                    this.$message.error('请输入账号和密码');
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            this.ishasData = true;
        },
        groupTitle(items) {
            return (
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总流量:' +
                items.data[0].TotalSpeed +
                't/h&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;占比方式:' +
                items.data[0].percentType
            );
        },
        getstructArr() {
            this.$zybhttp
                .get('Business/GetScaleGroupData', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var data = res.data.data.list;

                        //this.balanceArr = this.balanceArr;
                        var dataLength = data.length;
                        if (dataLength > 0) {
                            this.ishasData = true;
                        } else {
                            this.ishasData = false;
                        }
                        var darr = GroupbyName(data, 'ScaleGroupName');
                        this.balanceArr = darr;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        }
        // setCJHeight() {
        //     this.$nextTick(() => {
        //         // 页面渲染完成后的回调
        //         var headerHeight = document.getElementById('selSensor').offsetHeight + 30;
        //         this.screenheight = document.documentElement.clientHeight * 0.9 - headerHeight + 'px';
        //     });
        // }
    }
};
</script>


<style scoped>

.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.ms-title {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
}
.el-row {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.user-info-list {
    font-size: 18px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}
.odd {
    background: rgb(241, 239, 239);
    border-radius: 0.3rem;
}
.titleleftNo {
    width: 40%;
    padding-left: 0.5rem;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.titleleftYes {
    width: 40%;
    padding-left: 0.5rem;
    color: #1a8e83;
    font-weight: bold;
    font-family: 微软雅黑;
}
.contentleft {
    width: 60%;
    color: crimson;
    font-family: 微软雅黑;
}
.handle-box {
    margin-left: 10px;
}
.mr10 {
    margin-top: 10px;
    margin-right: 10px;
}
.el-card__header {
    background-color: cornsilk;
}
.sphead {
    font-size: 16px;
    color: #ab8f07;
    /* font-family: cursive; */
    font-family: 微软雅黑;
}
.nologin {
    float: right;
    font-size: 14px;
    color: red;
    margin-right: 10px;
    margin-top: 5px;
}
.spstate {
    float: right;
}
.contentrightNo {
    width: 60%;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentrightYes {
    width: 60%;
    font-weight: bold;
    color: #1a8e83;
    font-family: 微软雅黑;
}
</style>
<style>
.el-card__body {
    padding: 10px 20px;
    font-weight: 500;
}

element.style {
    background: #e0dcda;
}
.el-card__header {
    padding: 10px 20px;
}
</style>
<style>
.content-box {
    /* background: #9fdf0c;  */
    /* background: #020a27; */
    /* background: linear-gradient(to bottom, #6cb4f8 0%, #749dc4 60%, #559bca 100%); */
}
.el-dialog__body {
    padding-top: 10px;
}
</style>